import Vue from 'vue';
import VueRouter from 'vue-router';
import VueAxios from 'vue-axios';
import axios from 'axios';
import { getApiUrl } from '@/shared/utils/helpers';
import routes from './routes';
import { NotificationService } from '@/services/NotificationService';
import { clearAllCache } from '@/overmind/localStorage';
const axiosInstance = axios.create({
    baseURL: getApiUrl(),
    timeout: 1800000,
});
axiosInstance.interceptors.request.use(req => {
    const token = localStorage.getItem('auth_token_default');
    if (token) {
        req.headers = Object.assign({ Authorization: 'Bearer ' + token }, req.headers);
    }
    return req;
}, error => Promise.reject(error));
function generateError(response, defaultMessage) {
    const data = response.response.data;
    if (!data)
        return defaultMessage;
    if (data.error) {
        return data.error;
    }
    else if (data.description) {
        return data.description;
    }
    else if (data.message) {
        return data.message;
    }
    else if (Array.isArray(data.errors)) {
        const lastError = data.errors[0];
        return lastError.description || lastError.summary;
    }
    else {
        return defaultMessage;
    }
}
function logout() {
    // @ts-ignore
    Vue.auth.logout();
    setTimeout(() => {
        // @ts-ignore
        if (Vue.router.currentRoute.name !== 'login')
            window.location.href = '/login';
    }, 1000);
}
// handle network server errors
axiosInstance.interceptors.response.use(response => {
    if (response.data &&
        response.config &&
        response.config.url &&
        response.config.url.includes('allowed_success_notify'))
        NotificationService.success('Sucesso', response.data.message || 'Operação realizada com sucesso!');
    return Promise.resolve(response);
}, error => {
    if (error.response &&
        !error.response.config.url.includes('skip_handle_error')) {
        // @ts-ignore
        const user = Vue.auth.user();
        let internalErrorMessage = 'Ocorreu um erro inesperado. Nossa equipe já foi notificada.';
        if (user &&
            user.email.includes('@speedio.com.br') &&
            error.response.data) {
            internalErrorMessage = `
          detalhes: ${error.response.data.details},<br>
          endpoint: ${error.response.data.endpoint}
        `;
        }
        switch (error.response.status) {
            case 401:
                logout();
                NotificationService.warning('Alerta', 'Sua sessão foi encerrada! Efetue login novamente para continuar!');
                break;
            case 403:
                NotificationService.warning('Alerta', 'Sem permissões para a ação!');
                break;
            case 422:
            case 400:
            case 404:
                NotificationService.error('Erro', generateError(error, 'Nenhum resultado encontrado'));
                break;
            case 500:
                NotificationService.error('Servidor indisponível no momento!\nPor favor tente novamente mais tarde!', internalErrorMessage);
                break;
            default:
                if (error.response.config.url === 'user/me') {
                    clearAllCache();
                    logout();
                    NotificationService.error('Servidor indisponível no momento!\nPor favor tente novamente mais tarde!', internalErrorMessage);
                }
                break;
        }
    }
    return Promise.reject(error);
});
Vue.use(VueRouter);
Vue.use(VueAxios, axiosInstance);
// @ts-ignore TS2349: property inexistent
Vue.router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,
    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE,
});
// @ts-ignore TS2349: property inexistent
export default Vue.router;
